exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "input[type=checkbox].guify-checkbox {\n  display: none !important;\n  cursor: pointer; }\n\ninput[type=checkbox].guify-checkbox + label:before {\n  content: \"\";\n  display: inline-block;\n  width: 18px;\n  height: 18px;\n  padding: 0px;\n  vertical-align: middle;\n  margin-right: 8px;\n  margin-top: 1px;\n  background-color: #363636;\n  border-radius: 0px;\n  cursor: pointer; }\n\ninput[type=checkbox]:checked.guify-checkbox + label:before {\n  width: 10px;\n  height: 10px;\n  background-color: #707070;\n  border: solid 4px #363636;\n  cursor: pointer;\n  box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  -webkit-box-sizing: content-box; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/scss/components/checkbox.scss
// module id = 40
// module chunks = 0